"use client";

import React, { useState, useRef } from 'react';
import VideoModal from '@components/molecules/VideoModal/VideoModal';
import { DeviceType } from '@interfaces/video';
import { createVideoSource } from '@utils/videoUtils';
import assetLoader from '@utils/internalImageLoder';
import { EventType, trackEventWithCommonProps } from '@utils/eventTracker';
import { PAGE_TYPES } from '@constants/pageTypes';

interface VideoModalWrapperProps {
  children: React.ReactElement;
  cityName?: any;
}

const VideoModalWrapper: React.FC<VideoModalWrapperProps> = ({ children, cityName }) => {
  const [isVideoModalOpen, setisVideoModalOpen] = useState<boolean>(false);
  const videoTimeRef = useRef<{ currentTime: number; duration: number }>({ currentTime: 0, duration: 0 });
  
  const selectedMetadata = {
    authorName: "ACKO DRIVE",
    authorType: "ACKO DRIVE",
    duration: "127",
    mediaSource: "S3",
    primaryText: "Your car journey with expert support",
    secondaryText: "",
    thumbnail: "https://ackodrive-assets.s3.ap-south-1.amazonaws.com/video/tata/tiago-ev/default/thumbnail/tata-tiago-pro-and-cons-final_1.png",
    title: "Your car journey with expert support",
  };

  const handleModalClose = async () => {
    setisVideoModalOpen(false);
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.HOME_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_close_expert_video",
        city_name: cityName,
        closing_time: Math.floor(videoTimeRef.current.currentTime),
        total_time: Math.floor(videoTimeRef.current.duration)
      },
    });
  };

  const handleOpenModal = async () => {
    setisVideoModalOpen(true);
    // Reset video time tracking when opening modal
    videoTimeRef.current = { currentTime: 0, duration: 0 };
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.HOME_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_expert_video",
        city_name: cityName,
      },
    });
  };

  const handleTimeUpdate = (currentTime: number, duration: number) => {
    videoTimeRef.current = { currentTime, duration };
  };

  return (
    <>
      {React.cloneElement(children, { 
        onClick: handleOpenModal 
      } as any)}
      <VideoModal
        video={createVideoSource(`https://ackodrive-prod.ackoassets.com/video/generic/Acko+drive+2.0+-+Positioning+Video.mp4`)}
        metadata={selectedMetadata}
        isOpen={isVideoModalOpen}
        onClose={handleModalClose}
        deviceType={DeviceType.DESKTOP}
        config={{
          autoplay: true,
          muted: false,
          showTitle: true,
          showProgress: true,
          showVolume: true,
          showClose: true,
        }}
        events={{
          onPlay: () => console.log("Video started playing"),
          onPause: () => console.log("Video paused"),
          onEnded: () => console.log("Video ended"),
          onError: (error) => console.error("Video error:", error),
          onTimeUpdate: handleTimeUpdate,
        }}
      />
    </>
  );
};

export default VideoModalWrapper; 